<div class="flex relative mb-4">
  <proffeo-ui-input
    [(value)]="search"
    variant="search"
    placeholder="placeholders.search-input"
    class="grow-3"
  />
</div>

<div class="max-h-64 overflow-y-auto flex-grow">
  @for (company of filteredCompanies(); track company?.id; let isLast = $last) {
    <div class="flex items-center">
      <div
        [ngClass]="isLast ? '' : 'border-b border-proffeo-surface-off'"
        class="flex w-full items-center py-2"
      >
        <mat-radio-button
          (click)="selectCompany(company)"
          [value]="company.id"
          [checked]="selectedCompanyId() === company.id"
          class="mr-2 shrink-0"
        />
        <div class="ml-2 flex w-full flex-col truncate py-2">
          <p>{{ company?.name ?? company?.id }}</p>
        </div>
      </div>
    </div>
  }
</div>
